import {createReducer, on} from '@ngrx/store';

import * as fromCustomersModuleModels from '../../models';
import {PartnersActions} from '../actions';
import {ErrorsObject, getErrorsObject} from '../../../shared/utilities/error-utility.utility';
import {getAndHandleBackendErrors} from '../../../shared/utilities/reducer.utility';

export interface State {
  current: fromCustomersModuleModels.Customer;
  currentPartner: fromCustomersModuleModels.Customer;
  entities: { [iri: string]: fromCustomersModuleModels.Customer };
  errors: ErrorsObject;
  loaded: boolean;
  loading: boolean;
  pagination?: {
    current?: string;
    first?: string;
    last?: string;
    next?: string;
    previous?: string;
  };
  totalItems: number;
  searchEntities: Array<string>;
}

const initialState = {
  current: null,
  currentPartner: null,
  entities: {},
  errors: {},
  loaded: false,
  loading: false,
  searchEntities: [],
  totalItems: 0,
};

export const reducer = createReducer(
  initialState,
  on(
    PartnersActions.ReadPartner,
    PartnersActions.ReadPartners,
    (state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    })
  ),
  on(
    PartnersActions.ReadPartnerSuccess,
    (state, {response}) => {

      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        current: response,
        entities,
        loading: false,
        searchEntities: [response['@id']],
      };
    }
  ),
  on(
    PartnersActions.ReadPartnerSuccess,
    (state, {response}) => {

      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        currentPartner: response,
        entities,
        loading: false,
        // searchEntities: [response['@id']],
      };
    }
  ),
  on(
    PartnersActions.ReadPartnersSuccess,
    PartnersActions.ReadPartnerChunkSuccess,
    (state, {response}) => {

      const hasPagination = response.hasOwnProperty('hydra:view');
      const items = response['hydra:member'];
      const totalItems = response['hydra:totalItems'];
      let pagination = {};
      let searchEntities = [];

      const entities = items.reduce(
        (entities: { [id: string]: fromCustomersModuleModels.Customer }, item) => {
          return {
            ...entities,
            [item['@id']]: item
          };
        },
        // intentionally "reset" entities for proper pagination as opposed to accumulating values
        // todo: local caching? maybe use custom MatDataSource?
        {}
        // {...state.entities}
      );

      if (response.hasQueryParam) {

        items.forEach(item => {
          searchEntities = [...searchEntities, item['@id']];
        });
      }

      // Sample
      // "@id": "/api/customers?page=1",                          ---- always available
      // "hydra:first": "/api/customers?page=1",                  ---- always available
      // "hydra:next": "/api/customers?page=2"                    ---- might be unavailable
      // "hydra:previous": "/api/customers?page=2"                ---- might be unavailable
      // "hydra:last": "/api/customers?page=2",                   ---- always available

      if (hasPagination) {
        pagination = {
          first: response['hydra:view']['hydra:first'],
          current: response['hydra:view']['@id'],
          last: response['hydra:view']['hydra:last'],
        };

        if (response['hydra:view'].hasOwnProperty('hydra:previous')) {
          pagination = {...pagination, previous: response['hydra:view']['hydra:previous']};
        }

        if (response['hydra:view'].hasOwnProperty('hydra:next')) {
          pagination = {...pagination, next: response['hydra:view']['hydra:next']};
        }
      }

      return {
        ...state,
        entities,
        searchEntities,
        totalItems,
        pagination,
        loading: false,
        loaded: true,
      };
    }),
  on(
    PartnersActions.ReadPartnerFail,
    PartnersActions.ReadPartnersFail,
    (state, {type, response}) => {

      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false
      };
    }
  ),
  on(
    PartnersActions.ResetCurrentPartner,
    (state) => {

      return {
        ...state,
        current: null
      };
    }
  ),
  /*on(
    PartnersActions.ResetPartnersLoaded,
    (state) => {

      return {
        ...state,
        loaded: false
      };
    }
  )*/
);
